/**
 * What the seller just did that contradicts their Inactivo state. Drives the
 * prompt's opening line so the interruption explains itself (RET-1350).
 */
export enum eAvailabilityPromptReason {
  MESSAGE_SENT = 'message_sent',
  LEAD_MOVED = 'lead_moved',
}
